import { useMutation, useQueryClient } from '@tanstack/react-query';

import { ScheduleConfigService } from '@/openapi';
import { queryKeys } from '@/util/queryKeys';

export const useDeleteShiftMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (shiftId: number) => {
      return ScheduleConfigService.scheduleConfigServiceDeleteShift({
        path: { shiftId },
      });
    },
    onSettled: async () => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: queryKeys.shifts.list() }),
        queryClient.invalidateQueries({ queryKey: queryKeys.schedule.all }),
        queryClient.invalidateQueries({
          queryKey: queryKeys.holidays.withShifts(),
        }),
      ]);
    },
  });
};
